import { DmImportResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type DmImportResponseInput = z.input<typeof DmImportResponseSchema>;
export type DmImportResponseOutput = z.output<typeof DmImportResponseSchema>;

export function serializeDmImportResponse(payload: DmImportResponseInput): DmImportResponseOutput {
  return DmImportResponseSchema.parse(payload);
}
